/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Enable_Notetaker_BodyInputs */



/**
* | output |
* | --- |
* | "Turn the notetaker on for a conversation, and the report will be ready for you afterwards." |
*
* @param {Nudge_Enable_Notetaker_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_enable_notetaker_body = /** @type {((inputs?: Nudge_Enable_Notetaker_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Enable_Notetaker_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zet de notetaker aan voor een gesprek, dan staat het verslag er achteraf voor je klaar.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activez le notetaker pour une conversation, et le compte rendu sera prêt pour vous ensuite.")
	return /** @type {LocalizedString} */ ("Turn the notetaker on for a conversation, and the report will be ready for you afterwards.")
});